import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '1rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[20]}`,
    borderRadius: '0.5rem',
    marginBottom: '1rem',
  },
  sectionLabel: {
    margin: 0,
    fontWeight: 600,
    fontSize: '0.625rem',
    lineHeight: '1rem',
    letterSpacing: '0.075rem',
    textTransform: 'uppercase',
    color: neutral[60],
  },
  clientName: {
    margin: 0,
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    color: neutral[100],
  },
});
